export enum EntityType {
  Company = "Company",
  User = "User",
}

export interface UserDataType {
  id: string;
  type: EntityType.User;
  email: string;
  firstName: string;
  lastName: string;
}

export interface CompanyDataType {
  id: string;
  type: EntityType.Company;
  number: string;
  name: string;
}
